import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const logRequest = (args: any, timestamp: number) => {
    const { url, method = 'POST', body } = args;

    console.groupCollapsed(
        `%c📤 API REQUEST %c${method} %c${url}`,
        'color: #2196F3; font-weight: bold;',
        'color: #FF9800; font-weight: bold;',
        'color: #666; font-weight: normal;'
    );

    console.log('%cTimestamp:', 'font-weight: bold; color: #9C27B0;', new Date(timestamp).toISOString());
    console.log('%cMethod:', 'font-weight: bold; color: #9C27B0;', method);
    console.log('%cURL:', 'font-weight: bold; color: #9C27B0;', url);

    if (body) {
        try {
            const parsedBody = typeof body === 'string' ? JSON.parse(body) : body;

            if (parsedBody.query) {
                console.log('%cGraphQL Query:', 'font-weight: bold; color: #9C27B0;');
                console.log(parsedBody.query);
            }

            if (parsedBody.variables) {
                console.log('%cVariables:', 'font-weight: bold; color: #9C27B0;', parsedBody.variables);
            }

            console.log('%cFull Body:', 'font-weight: bold; color: #9C27B0;', parsedBody);
        } catch (e) {
            console.log('%cBody:', 'font-weight: bold; color: #9C27B0;', body);
        }
    }

    console.groupEnd();
};

const logResponse = (result: any, timestamp: number, duration: number) => {
    const isError = result.error;
    const status = result.meta?.response?.status || (isError ? 'ERROR' : 200);

    const statusColor = status >= 200 && status < 300 ? '#4CAF50' : '#F44336';

    console.groupCollapsed(
        `%c📥 API RESPONSE %c${status} %c(${duration}ms)`,
        'color: #4CAF50; font-weight: bold;',
        `color: ${statusColor}; font-weight: bold;`,
        'color: #666; font-weight: normal;'
    );

    console.log('%cTimestamp:', 'font-weight: bold; color: #9C27B0;', new Date(timestamp).toISOString());
    console.log('%cStatus:', 'font-weight: bold; color: #9C27B0;', status);
    console.log('%cDuration:', 'font-weight: bold; color: #9C27B0;', `${duration}ms`);

    if (result.meta?.response?.headers) {
        console.log('%cHeaders:', 'font-weight: bold; color: #9C27B0;', result.meta.response.headers);
    }

    if (isError) {
        console.error('%cError:', 'font-weight: bold; color: #F44336;', result.error);
    } else if (result.data) {
        console.log('%cData:', 'font-weight: bold; color: #9C27B0;', result.data);
    }

    console.log('%cFull Response:', 'font-weight: bold; color: #9C27B0;', result);

    console.groupEnd();
};

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000/api/graphql',
    credentials: 'include',
    prepareHeaders: (headers) => {
        return headers;
    },
});

// Custom baseQuery with GraphQL error handling and logging
const baseQueryWithErrorHandling = async (args: any, api: any, extraOptions: any) => {
    const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.NODE_ENV === 'production';
    const requestTimestamp = Date.now();
    if (!isProduction) logRequest(args, requestTimestamp);
    const result = await baseQuery(args, api, extraOptions);
    const responseTimestamp = Date.now();
    const duration = responseTimestamp - requestTimestamp;
    if (!isProduction) logResponse(result, responseTimestamp, duration);

    // Handle GraphQL errors
    if (result.data && (result.data as any).errors) {
        return {
            error: {
                status: 'CUSTOM_ERROR',
                data: result.data,
            },
        };
    }

    return result;
};

export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithErrorHandling,
    tagTypes: ['User', 'Company', 'Job', 'Talent', 'SectorType', 'ChatSession', 'Message', 'CompanyUser', 'Location', 'Contact', 'Review', 'Listing'],
    endpoints: () => ({}),
});
